"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ScreenShareReadiness = require("./ScreenShareReadiness");
Object.keys(_ScreenShareReadiness).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ScreenShareReadiness[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ScreenShareReadiness[key];
    }
  });
});